import React from 'react';
import styled from 'styled-components';
import { Bell, Search } from 'lucide-react';

const HeaderContainer = styled.header`
  background: ${props => props.theme.colors.surface};
  border-bottom: 1px solid ${props => props.theme.colors.border};
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.theme.colors.background};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  min-width: 300px;
`;

const SearchInput = styled.input`
  border: none;
  background: none;
  outline: none;
  flex: 1;
  margin-left: ${props => props.theme.spacing.sm};
  color: ${props => props.theme.colors.text};
  
  &::placeholder {
    color: ${props => props.theme.colors.textSecondary};
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
`;

const ActionButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.theme.colors.primary};
    color: white;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  background: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.borderRadius.md};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.theme.colors.primary};
    color: white;
  }
`;

const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
`;

const UserName = styled.div`
  font-weight: 500;
`;

const UserRole = styled.div`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.textSecondary};
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: ${props => props.theme.colors.error};
  border-radius: 50%;
  border: 2px solid ${props => props.theme.colors.surface};
`;

function Header({ admin }) {
  const initials = (admin?.full_name || admin?.email || 'A')
    .split(' ')
    .filter(Boolean)
    .map(chunk => chunk[0]?.toUpperCase())
    .slice(0, 2)
    .join('') || 'A';

  return (
    <HeaderContainer>
      <SearchBar>
        <Search size={20} color="#6b7280" />
        <SearchInput placeholder="Поиск..." />
      </SearchBar>

      <HeaderActions>
        <div style={{ position: 'relative' }}>
          <ActionButton>
            <Bell size={20} />
          </ActionButton>
          <NotificationBadge />
        </div>
        
        <UserInfo>
          <UserAvatar>{initials}</UserAvatar>
          <div>
            <UserName>{admin?.full_name || admin?.email}</UserName>
            <UserRole>{admin?.role || 'admin'}</UserRole>
          </div>
        </UserInfo>
      </HeaderActions>
    </HeaderContainer>
  );
}

export default Header;
